import { FC, ReactNode } from 'react';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

export interface AppBarProps extends MuiAppBarProps {
  internalBar?: ReactNode;
  children?: ReactNode;
}

/**
 * Main application bar. It's fixed to the top of the viewport. Part of main application bar is internal bar.
 * If internal bar is present, it can be visible or hidden because of the "eye-button".
 *
 * @deprecated Use `@o2/common-business/AppBar` instead.
 */
const AppBar: FC<AppBarProps> = (props) => {
  const { internalBar, children, ...other } = props;

  return (
    <MuiAppBar position="fixed" color="primary" {...other}>
      {internalBar}
      <Toolbar sx={{ justifyContent: 'space-between' }}>{children}</Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
